import Box from '@mui/material/Box'
import { Theme, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const PageWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const PagePaper = styled('div')`
  margin: 0 ${componentSizes.smDistance} 0 0;
`

export const PagePaperInner = styled('div')`
  background-color: ${colors.white};
  padding: ${componentSizes.smDistance} ${componentSizes.smDistance} 0;
  border: 1px solid #dadada;
  position: relative;
  overflow: hidden;
`

export const TitleContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

export const SubtitleContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
export const SubtitleInner = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: ${colors.primary};
  width: fit-content;
`

export const TableNavigationBox = styled(Box)`
  margin-top: 16px;
  margin-bottom: ${componentSizes.smDistance};

  &:first-child {
    margin: ${componentSizes.smDistance} 0 0;
  }
  &:last-child {
    margin-bottom: ${componentSizes.smDistance};
  }
`

export const TopTabsNavigationContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-left: ${componentSizes.smDistance};
  margin-bottom: ${componentSizes.smDistance};
  max-height: 48px;
`

export const TabsWrapper = styled('div')`
  max-width: 60%;
  margin-right: 40px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    max-width: 100%;
  }
`
